import { UIText3, UIText2 } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './OffersStatsItemMobile.css';

import { Link } from '../Link';
import { IOffersStatsItem } from './OffersStatsItem';

export const OffersStatsItemMobile = (props: IOffersStatsItem) => {
  return (
    <div className={styles['offer']}>
      <div className={styles['room']}>
        <UIText2>
          {props.roomType} {props.totalAreaMinDisplay}
        </UIText2>
        <div className={styles['price']}>
          <UIText3>{props.price2Range}</UIText3>
        </div>
      </div>
      <div className={styles['offers']}>
        <Link target="_blank" url={props.offersUrl}>
          <div className={styles['link']}>
            <div className={styles['props-count']}>{props.fromDeveloperPropsCount}</div>
            <IconActionChevronRightSmall16 color="icon-main-default" />
          </div>
        </Link>
      </div>
    </div>
  );
};
